// extracted by mini-css-extract-plugin
export var standaloneTable = "_ez-0";
export var withExtraHeader = "_ez-1";